import { ApiResult, request, safeRequest } from '@synergy/api';

import { StaticSites } from '../models/static-sites';
import { StaticSitesDetailRequest } from '../models/static-sites-detail-request';

export class StaticSitesDetailApi {
    constructor(protected baseUrl: string) {}

    public getStaticSitesDetail(id: number): Promise<ApiResult<StaticSites>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/static-sites/${id}`),
            response => response.data
        );
    }

    public updateStaticSitesDetail = (staticSites: StaticSitesDetailRequest): Promise<ApiResult<StaticSites>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/static-sites/${staticSites.id}`, staticSites),
            response => response.data
        );
    };

    public createStaticSitesDetail = (staticSites: StaticSitesDetailRequest): Promise<ApiResult<StaticSites>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/static-sites`, staticSites),
            response => response.data
        );
    };
}
